import BaseObject from '../../../../base/base_object';
import {FEATURE_CB_FUNC, KEY_NAME, SERIVCES_FUNC_LIST} from '../../native/native_const';
import Device from '../../../../utils/device/device';
import {ON_DEMAND} from "./on_demand_hybrid_consts";
import ServiceFactory from "../../../service_factory";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from "../../../../utils/event";
import _ from "../../../../utils/underscore";
import DOM from "../../../../utils/dom";
import {BRANDS} from "../../../regulation/regulation_const";
import  {UK_STRIP_COMPONENT_SELECTOR} from "../../../../components/regulation_components/uk/game_stripe/uk_game_stripe_component.ts"
import {CANADA_ONTARIO_STRIP_COMPONENT_SELECTOR} from "../../../../components/regulation_components/canada/ontario/game_stripe/canada_ontario_game_stripe_component";
import {SPAIN_STRIP_COMPONENT_SELECTOR} from "../../../../components/regulation_components/spain/game_stripe/spain_game_stripe_component";



class OnDemandNyx extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OnDemandNyx';
    static NYX_TYPE = 'NYX';

    _HybridService = null;
    _bUpdateHeaderHeight = false;
    _onDemandGameIsRunning = false;

    init(params) {

        super.init();
        if (_.isNullOrUndefined(params)) {
            return;
        }
        if (Device.os.isIOS) {
            params = params.ios;
            if (_.isNullOrUndefined(params)) {
                return;
            }

            if (!_.isNullOrUndefined(params.headerShift)) {
                this._bUpdateHeaderHeight = params.headerShift.enable;
            }
        }
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        if (Device.hybrid.isEmbedded) {
            this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_SET_CB, FEATURE_CB_FUNC.HYBRID_ON_DEMAND_NYX_CALL);
        }
        return this;
    }

    canHandle(companyName) {
        return OnDemandNyx.NYX_TYPE === companyName;
    }

    navigate(companyName, url) {
        if (this.canHandle(companyName)) {
            Event.on(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, this._onResize, this);
            Event.once(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH,(status)=>{
                this._onGameSequenceFinish(status)
            }, this)


            this._HybridService.navigateForOnDemandNyx(url);
            this._updateHeaderheight();
            this._onDemandGameIsRunning = true;
            return true;
        }

        return false;
    }

    _getHeaderheight(){
        //todo refactor  this function, we need to remove it, the game step need to send new event to Hybrid to move the web view down with X pixel
        let headerClassName = '.cy-header-regulation-data';

        const headerShiftDisable =  !this._bUpdateHeaderHeight;
        const netPositionDisable =  !this._HybridService.serviceFactory.regulationService().getRegulation().showNetPosition();

        if(headerShiftDisable && netPositionDisable){
            return 0;
        }

        const brandID = this._HybridService.serviceFactory.skinService().getBrandID();

        if(this._HybridService.serviceFactory.skinService().isCOMBrand()){
            headerClassName =  '.' + UK_STRIP_COMPONENT_SELECTOR;
        }else if(BRANDS.SPAIN === brandID){
            headerClassName =  '.' + SPAIN_STRIP_COMPONENT_SELECTOR;
        }else if(BRANDS.CANADA === brandID){
            headerClassName =  '.' + CANADA_ONTARIO_STRIP_COMPONENT_SELECTOR;
        }

        const topHeader = DOM.querySelector(headerClassName); //todo should be refactor and use  await ServiceFactory.create().integrationService().getHeaderRegulationDataElement()

        return topHeader ? topHeader.offsetHeight : 0;
    }

    _getBrandenable(){
        const isEnable = this._HybridService.serviceFactory.regulationService().getRegulation().hybridNyxClosedButtonEnabled();
        return isEnable ? 'true' : 'false'
    }

    _getCloseButPosition(){

        let xp = 0;
        let yp = 0;
        let xl = 0;
        let yl = 0;

        if(Device.hybrid.isEmbedded && !Device.hybrid.inPoker && !Device.hybrid.inSport) {
            if(Device.isIphoneX()) {
                xp = -10;
                yp = 10;
                xl = -10;
                yl = 20;
            }
        }

        let enable = this._getBrandenable();

        let dt = {
            'enable': enable,
            'xp': xp,
            'yp': yp,
            'xl': xl,
            'yl': yl
        };

        return dt;
    }

    _updateHeaderheight(){

        let headerheight = this._getHeaderheight();

        let dt = this._getCloseButPosition();

        this._HybridService.changeHeaderHeightOnDemandNyx(headerheight, dt);
    }

    _onResize() {
        this._updateHeaderheight();
    }

    _onGameSequenceFinish(status){
        if(status) {
            this._updateHeaderheight();
        }
    }

    onHybridDirectCall(data) {

        let fn = this.getFuncName(data);

        if ('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    getFuncName(data) {
        let fn = data[ON_DEMAND.CB_FN];

        return undefined !== fn ? fn : '';
    }

    onNyxEvent(data) {

        let reason = this._getReason(data);

        let isClose = ServiceFactory.create().gameReasonService().handleReason(reason);
        if (isClose) {
            this.onclose();
        }
    }

    onNyxPostMsg(data){

        let msg = {
            data: {}
        };

        try {
            let val = data[KEY_NAME.DATA];
            msg.data.gcmevent = decodeURIComponent(val);
        }
        catch (e) {
            msg.data.gcmevent = '';
        }

        Event.fire(SYSTEM_EVENTS.HYBRID_POST_MESSAGE_ARRIVE, msg);
    }

    onclose() {
        this._HybridService.closeNyxODRGame();
        this._onDemandGameIsRunning = false;
        Event.off(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, this._onResize, this);
    }

    isOnDemandStandAloneGameRunning() {
        return this._onDemandGameIsRunning;
    }

    _getReason(data) {

        let url;

        try {
            let val = data[KEY_NAME.DATA];
            url = decodeURIComponent(val);
        }
        catch (e) {
            url = null;
        }

        if (null === url) {
            return null;
        }

        let extractFirstPart = url.split('?')[1];

        if ('undefined' === typeof extractFirstPart) {
            return null;
        }

        let allowedPattern = /^reason=([0-9]{1,2})/,
            matchedURL = extractFirstPart.match(allowedPattern),
            reasonID = Array.isArray(matchedURL) ? Number(matchedURL[1]) : false;

        return reasonID;
    }

}
export default OnDemandNyx;
